import { Dialog, DialogContent, DialogTitle, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import { EconsultUtils } from '@oh-vcp/components-common';
import { EconsultCancelButton, EconsultActionButton } from '@oh-vcp/components-ui';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface EconsultCompleteCaseDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onComplete: () => void;
}

const EconsultCompleteCaseDialog: FC<EconsultCompleteCaseDialogProps> = ({
  isOpen,
  onClose,
  onComplete
}) => {
  const { t } = useTranslation();
  const isMobile = EconsultUtils.isMobileDevice();
  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle>
        <Typography variant="h2" color="base.grey4">
          {t('Case.consult.completeCase')}
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ width: isMobile ? '80vw' : 400 }}>
        <Typography color="base.grey4" mb={1}>
          {t('Case.consult.completeCase2')}
        </Typography>
        <Typography color="base.grey4" mb={3}>
          {t('Case.consult.completeCase3')}
        </Typography>
        <Stack direction="row" justifyContent={isMobile ? 'center' : 'end'}>
          <EconsultActionButton
            variant="contained"
            color="primary"
            sx={{ mr: 1 }}
            onClick={onComplete}>
            {t('Case.button.complete')}
          </EconsultActionButton>
          <EconsultCancelButton variant="contained" onClick={onClose}>
            {t('Case.button.cancel')}
          </EconsultCancelButton>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default EconsultCompleteCaseDialog;
